/** Owner-editable placeholder copy for the deployed-build notice. */
export const CONSOLE_UPDATE_COPY = {
  title: 'A new version of the console is available.',
  reloadLabel: 'Reload',
} as const;
